import { ModuleWithProviders, NgModule } from '@angular/core';
import { MIXPANEL_TOKEN, MixpanelService } from './mixpanel.service';

@NgModule({})
export class MixpanelModule {
  static forRoot(token: string): ModuleWithProviders<MixpanelModule> {
    return {
      ngModule: MixpanelModule,
      providers: [
        MixpanelService,
        { provide: MIXPANEL_TOKEN, useValue: token },
      ],
    };
  }
}